var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.424,
    height: 29.502,
    viewBox: "0 0 23.424 29.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.159,26.868A2.637,2.637,0,0,1,73.52,29.5H55.374a2.637,2.637,0,0,1-2.639-2.634V2.634A2.637,2.637,0,0,1,55.374,0h11.3a1.981,1.981,0,0,1,1.4.58l7.509,7.51a1.973,1.973,0,0,1,.578,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#f34646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.328,11.591h-6.706a1.785,1.785,0,0,1-1.784-1.785V3.1a1.961,1.961,0,0,1,.58.4l7.51,7.51a1.961,1.961,0,0,1,.4.579Z",
    transform: "translate(-292.802 -2.922)",
    fill: "#f77e7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "translate(10.845 14.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9799",
    "data-name": "Path 9799",
    d: "M336.267,262.475a.445.445,0,1,0,0-.89h-2.722a.445.445,0,0,0-.445.445v6.717a.445.445,0,1,0,.89,0V265.77h2.061a.445.445,0,0,0,0-.89h-2.061v-2.4Z",
    transform: "translate(-326.51 -261.585)",
    fill: "#f9f8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9800",
    "data-name": "Path 9800",
    d: "M221.05,262.891h-1.86a.445.445,0,0,0-.445.446v.006h0V269.8a.444.444,0,0,0,.013.106v0a.445.445,0,0,0,.445.444h0c.056,0,1.38-.005,1.907-.014a2.84,2.84,0,0,0,2.242-1.141,4.238,4.238,0,0,0,.793-2.573C224.147,264.389,222.9,262.891,221.05,262.891Zm.047,6.552c-.331.006-1,.01-1.45.012,0-.734-.007-2.182-.007-2.843,0-.552,0-2.07,0-2.831h1.414c1.627,0,2.207,1.466,2.207,2.838C223.256,268.26,222.368,269.421,221.1,269.443Z",
    transform: "translate(-218.745 -262.816)",
    fill: "#f9f8f9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9801",
    "data-name": "Path 9801",
    d: "M109.225,261.64h-1.9c-.389,0-.409.169-.409.409v6.822a.409.409,0,0,0,.818,0v-2.557c.444,0,1.148-.006,1.491-.006a2.335,2.335,0,1,0,0-4.668Zm0,3.85c-.341,0-1.034,0-1.48.006,0-.456-.006-1.175-.006-1.522,0-.292,0-1.043,0-1.516h1.489a1.517,1.517,0,1,1,0,3.032Z",
    transform: "translate(-101.899 -246.889)",
    fill: "#f9f8f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.380c55c5d4dc455815269cae67d9f245.svg";
export { ForwardRef as ReactComponent };